import { current } from "immer";

import { Session } from "../../Authentication";
import { BillSplitActions, BillSplitReducer } from "../BillSplit/reducer";
import { CartActions, cartReducer, generateEmptyCart } from "../Cart/reducer";
import { Customer } from "../Customer/schema";
import { CustomerTab } from "../CustomerTab/schema";

type CustomerTabActions = {
  action: "updateCustomerTab";
  payload: CustomerTab | null;
};
export type SessionActions =
  | { action: "initializeSession"; payload: Session }
  | CartActions
  | CustomerTabActions;
export const sessionReducer = (
  session: Session,
  action: SessionActions,
): Session | undefined => {
  console.log("sessionReducer", { session: current(session), action });
  {
    switch (action.action) {
      case "initializeSession":
        return action.payload;
      case "updateCustomerTab":
        session.customerTab = action.payload;
        return;
      case "closeCart":
        session.cart = generateEmptyCart({ venueId: session.cart.venueId });
        return;
      default:
        cartReducer(session.cart, action);
    }
  }
};
